import Dropdown from 'components/Form/Dropdown';
import InputHidden from 'components/Form/InputHidden';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import Layout from 'components/Layout';
import LinkButton from 'components/LinkButton';
import {FC, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';
import {setUrl} from 'utils/request';

import {
    CustomTemplatesViewBackendData,
    CustomTemplatesViewFilterFormData,
} from '../../types';

type FilterProps = {
    filterFormValue: string;
    isAboveBreakpoint: boolean;
};

const Filter: FC<FilterProps> = ({filterFormValue, isAboveBreakpoint}) => {
    const {
        data: {defaultFilteredValues, documentStates, documentTypes},
    } = useBackend<CustomTemplatesViewBackendData>();

    const methods = useForm<CustomTemplatesViewFilterFormData>({
        defaultValues: {
            document_type:
                defaultFilteredValues.filterForm === filterFormValue ||
                defaultFilteredValues.filterForm === 'filter_all'
                    ? defaultFilteredValues.documentType
                    : '',
            search:
                defaultFilteredValues.filterForm === filterFormValue ||
                defaultFilteredValues.filterForm === 'filter_all'
                    ? defaultFilteredValues.search
                    : '',
            state:
                defaultFilteredValues.filterForm === filterFormValue ||
                defaultFilteredValues.filterForm === 'filter_all'
                    ? defaultFilteredValues.state
                    : '',
        },
    });

    const [isFiltered] = useState(() => {
        const isFilterKeyMatched =
            defaultFilteredValues.filterForm === filterFormValue ||
            defaultFilteredValues.filterForm === 'filter_all';

        const areAllValuesEmpty =
            defaultFilteredValues.documentType === '' &&
            defaultFilteredValues.search === '' &&
            defaultFilteredValues.state === '';

        return isFilterKeyMatched && !areAllValuesEmpty;
    });

    const handleFilter = (formData: CustomTemplatesViewFilterFormData) => {
        const builtUrl = new URL(window.location.href.split('?')[0]);

        const queryParameters = new URLSearchParams(builtUrl.search);

        Object.entries(formData).forEach(([key, value]) =>
            queryParameters.append(key, String(value)),
        );

        builtUrl.search = queryParameters.toString();

        setUrl(builtUrl.toString());
    };

    return (
        <FormProvider {...methods}>
            <form
                className="w-full"
                onSubmit={methods.handleSubmit(handleFilter)}
            >
                <Layout.Chain className="mt-4">
                    <InputText
                        classNameInput={twMerge(
                            isAboveBreakpoint ? 'w-40' : 'w-32',
                        )}
                        isCompact={true}
                        name={'search'}
                        placeholder={t`Search`}
                    />
                    <Dropdown
                        className="w-48"
                        isCompact={true}
                        isSearchable={true}
                        name={'document_type'}
                        options={documentTypes}
                        placeholder={t`All Document Types`}
                        type="select"
                    />
                    <Dropdown
                        className={twMerge(isAboveBreakpoint ? 'w-40' : 'w-32')}
                        isCompact={true}
                        name={'state'}
                        options={documentStates}
                        placeholder={t`All`}
                        type="select"
                    />
                    <InputHidden name="filter_form" value={filterFormValue} />
                    <SubmitButton
                        icon="search"
                        kind="secondary"
                        size="sm"
                        title={t`Filter`}
                    />
                    {isFiltered && (
                        <LinkButton
                            href={window.Urls.customtemplate_list_view()}
                            icon="close"
                            kind="secondary"
                            size="sm"
                            title={t`Clear`}
                        />
                    )}
                </Layout.Chain>
            </form>
        </FormProvider>
    );
};

export default Filter;
